import { createReducer, on } from '@ngrx/store';
import {
    loadProfessionTree,
    loadProfessionTreeFailure,
    loadProfessionTreeSuccess
} from '../actions/profession-specialty-configuration.actions';
import { ProfessionSpecialtyConfigurationState } from '../state/profession-specialty-configuration.state';

export const professionSpecialtyConfigurationReducer = createReducer(
    {} as ProfessionSpecialtyConfigurationState,

    // loadProfessionTree
    on(loadProfessionTree, (state) => ({
        ...state,
        error: undefined
    })),

    // loadProfessionTreeSuccess
    on(loadProfessionTreeSuccess, (state, action) => ({
        ...state,
        professionTree: action.data,
        error: undefined
    })),

    // loadProfessionTreeFailure
    on(loadProfessionTreeFailure, (state, action) => ({
        ...state,
        professionTree: undefined,
        error: action.error
    }))
);
